export const bluetoothStates = {
    CONNECTING: "Łączenie z trenażerem",
    UUIDS: "Ustawianie identyfikatorów",
    GATT: "Aktualizowanie punktów kontrolnych",
    CALLBACK: "Ustawianie obsługi komunikatów trenażera",
    SUB: "Subskrybowanie punktów kontrolnych",
    CONNECTED: "Połączono",
};
